import { render, staticRenderFns } from "./FIReportsList.vue?vue&type=template&id=b99815b8&"
import script from "./FIReportsList.vue?vue&type=script&lang=js&"
export * from "./FIReportsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports